/**
 * @file
 * A JavaScript file containing footer block folding functionality
 *
 */

(function (Drupal, $) {
  Drupal.behaviors.footerColumn = {
    attach: function (context) {
      "use strict";
      $(once("footer-folding", ".footer-column__regions .footer-info__header", context))
        .each(function () {
          $(this).on("click", function () {
            if (window.matchMedia("(max-width: 759px)").matches) {
              $(this).toggleClass('open');
              var info = $(this).siblings(".footer-info__content");
              info.slideToggle(300);
            }
          });
        });
    },
  };
})(Drupal, jQuery);
